/* global Glide, Masonry, Accordion, AOS */
document.addEventListener("DOMContentLoaded", function () {
	initAOSClasses();
	AOS.init();
	ps_initThemeToggle();
	handleStickyHeaderOnScroll();
	ps_initAccordionTabs();
	initClickableCards();
	handlePSRelatedCaseStudiesLayout();
});
//Initialize Accordion
if (document.querySelector(".accordion-container")) {
	new Accordion(".accordion-container");
}

if (document.querySelector(".ps-carousel-one")) {
	if (document.querySelector(".glide__slides")) {
		var allSlides = document.querySelectorAll(".glide");
		var allSlidesArray = Array.prototype.slice.call(allSlides);
		allSlidesArray.forEach((slide) => {
			const glide = new Glide(slide, {
				type: "carousel",
				perView: 4, // Display 4 slides per view
				perTouch: 1,
				focusAt: 0, // Focus on the first slide
				autoplay: false,
				accessibility: true,
				startAt: 0,
				rewind: true,
				draggable: true,
				swipeThreshold: 80,
				dragThreshold: 120,
				classes: {
					disabledArrow: "glide__arrow--disabled",
				},
				peek: {
					before: 0, // No peek before, showing the full leftmost slide
					after: 150, // Showing half of the rightmost slide
				},
				breakpoints: {
					800: {
						perView: 3.5, // Adjust for smaller screens if necessary
						draggable: true,
						perTouch: 1,
						startAt: 0,
						peek: 0,
						swipeThreshold: 10,
						dragThreshold: 20,
					},
					peek: {
						before: 0, // No peek before, showing the full leftmost slide
						after: 150, // Showing half of the rightmost slide
					},
				},
			}).mount();
		});
	}
}

// version 2 carousel
if (document.querySelector(".ps-carousel-two")) {
	var allSlides2 = document.querySelectorAll(".glide");
	var allSlidesArray2 = Array.prototype.slice.call(allSlides2);
	allSlidesArray2.forEach((slide) => {
		const glide = new Glide(slide, {
			type: "carousel",
			perView: 4, // Display 4 slides per view by default
			perTouch: 1,
			focusAt: 0, // Focus on the first slide
			autoplay: false,
			accessibility: true,
			startAt: 0,
			rewind: true,
			draggable: true,
			swipeThreshold: 80,
			dragThreshold: 120,
			classes: {
				disabledArrow: "glide__arrow--disabled",
			},
			peek: {
				before: 50, // No peek before, showing the full leftmost slide
				after: 150, // Showing half of the rightmost slide
			},
			breakpoints: {
				800: {
					perView: 3, // Show 3 slides per view on smaller screens (mobile)
					perTouch: 1,
					draggable: true,
					startAt: 0,
					peek: 0,
					swipeThreshold: 10,
					dragThreshold: 20,
				},
				peek: {
					before: 100, // No peek before, showing the full leftmost slide
					after: 150, // Showing half of the rightmost slide
				},
			}
		}).mount();
	});
}



//Check if Header Button link is external
const btns = document.querySelectorAll(".wp-block-button__link");
const allBtns = Array.prototype.slice.call(btns);
const currentHost = window.location.hostname;

let externalText = document.createElement("span");
externalText.append(document.createTextNode("link will open external site"));
externalText.classList.add("screen-reader-text");

if (btns) {
	allBtns.forEach((btn) => {
		if (btn.hasAttribute("href")) {
			let ctaLink = btn.getAttribute("href").split("/");

			if (ctaLink[2] !== currentHost) {
				btn.classList.add("external-link");
				btn.append(externalText);
			}
		}
	});
}
if (document.querySelector(".cta-btn")) {
	let currentHost = window.location.hostname;
	let ctaBtn = document.querySelector(".cta-btn");
	let ctaLink = ctaBtn.getAttribute("href").split("/");

	if (ctaLink[0] !== currentHost) {
		ctaBtn.classList.add("external-link");
		ctaBtn.append(externalText);
	}
}


////Pagination
if (document.querySelector(".navigation-pagination")) {
	let paginationList = document.querySelectorAll(".navigation-pagination ul li");

	if (paginationList[0].classList.contains("active")) {
		paginationList[0].style.position = "relative";
	}

	if (paginationList[paginationList.length - 1].classList.contains("active")) {
		paginationList[paginationList.length - 1].style.position = "relative";
	}
}

////Masonary
if (document.querySelector(".allcontainer")) {
	var elem = document.querySelector(".allcontainer");
	var msnry = new Masonry(elem, {
		// options
		itemSelector: ".item",
		columnWidth: ".grid-sizer",
		gutter: 15,
	});

	let allblocks = Array.prototype.slice.call(document.querySelectorAll(".item"));
	let selectedValue;
	let selectedOption;
	let availableItems;
	let buttons = document.querySelectorAll(".filters button"); //returns a nodelist

	for (let i = 0; i < buttons.length; i++) {
		buttons[i].addEventListener("click", onClickChange);
	}

	//Click Filter
	function onClickChange() {
		selectedValue = this.value;

		allblocks.forEach(function (block) {
			block.classList.remove("block");

			if (selectedValue == "all") {
				block.classList.add("block");
			}

			if (block.getAttribute("data-cat") == selectedValue) {
				block.classList.add("block");
			}
		});
		msnry.layout();

		availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));
		document.getElementById("select").addEventListener("change", onSelectChange);
	}

	availableItems = Array.prototype.slice.call(document.querySelectorAll(".item.block"));

	document.getElementById("select").addEventListener("change", onSelectChange);

	function onSelectChange() {
		selectedOption = this.value;

		availableItems.forEach(function (item) {
			item.classList.remove("block");

			if (selectedOption == "all") {
				item.classList.add("block");
			}

			if (item.getAttribute("data-tag") == selectedOption) {
				item.classList.add("block");
			}
		});

		//Filter Click
		for (let i = 0; i < buttons.length; i++) {
			buttons[i].addEventListener("click", onClickChange);
		}

		msnry.layout();
	}

	/////Script_AJAX
	/* Ajax functions */
	$(document).ready(function () {
		//onclick
		$("#loadMore").on("click", function (e) {
			e.preventDefault();
			//init
			var that = $(this);
			var page = $(this).data("page");
			var newPage = page + 1;
			var ajaxurl = that.data("url");
			//ajax call
			$.ajax({
				url: ajaxurl,
				type: "post",
				data: {
					page: page,
					action: "ajax_script_load_more",
				},
				error: function (response) {
					console.log(response);
				},
				success: function (response) {
					//check
					if (response == 0) {
						$(".allcontainer").append('<div class="text-center no-more-post"><h4>You reached the end of the line!</h4><p>No more posts to load.</p></div>');
						$("#loadMore").hide();
					} else {
						that.data("page", newPage);
						$("#ajax-primary").append(response);

						msnry = new Masonry(elem, {
							// options
							itemSelector: ".item",
							columnWidth: ".grid-sizer",
							gutter: 15,
						});

						msnry.layout();
					}
				},
			});
		});
	});
}

//Breadcrumb Spacing
if (document.querySelector(".breadcrumb-container")) {
	document.querySelector(".content-area").style.marginTop = 0;
}

//Button Custom Colors Hover
var customBtn = $(".wp-block-button a.has-text-color.has-background");

customBtn.each(function (index) {
	var btnbgColor = $(this).css("backgroundColor");
	var btnColor = $(this).css("color");

	$(this)
		.mouseenter(function () {
			$(this).css({
				"background-color": btnColor,
				color: btnbgColor,
				"border-color": btnColor
			});
		})
		.mouseleave(function () {
			$(this).css({
				"background-color": btnbgColor,
				color: btnColor,
				"border-color": btnbgColor
			});
		});
});

// global classes for animations
function initAOSClasses() {
	let all_firstslide = document.querySelectorAll(".aos-fade-left-five-h");
	let all_secondslide = document.querySelectorAll(".aos-fade-left-eight-h");
	let all_thirdslide = document.querySelectorAll(".aos-fade-left-twelve-h");
	//  Fade left animation
	let aos_fade_left_animation = document.querySelectorAll(".aos-fade-left,.is-style-aos-fade-left");
	//  Fade right animation
	let aos_fade_right_animation = document.querySelectorAll(".aos-fade-right,.is-style-aos-fade-right");
	//  Fade right animation slow
	let aos_fade_right_slow_animation = document.querySelectorAll(".aos-fade-right-slow");
	//  Fade up animation
	let aos_fade_up_animation = document.querySelectorAll(".aos-fade-up,.is-style-aos-fade-up");
	//  Fade down animation
	let aos_fade_down_animation = document.querySelectorAll(".aos-fade-down");
	//  Zoom in animation
	let aos_zoom_in_animation = document.querySelectorAll(".aos-zoom-in,.is-style-aos-zoom-in");
	//  Zoom out animation
	let aos_zoom_out_animation = document.querySelectorAll(".aos-zoom-out");

	//  Flip left animation
	let aos_flip_left_animation = document.querySelectorAll(".aos-flip-left");
	//  Flip right animation
	let aos_flip_right_animation = document.querySelectorAll(".aos-flip-right");
	//  Flip up out animation
	let aos_flip_up_animation = document.querySelectorAll(".aos-flip-up");
	//  Flip down animation
	let aos_flip_down_animation = document.querySelectorAll(".aos-flip-down");
	//  Zoom in up animation
	let aos_zoom_in_up_animation = document.querySelectorAll(".aos-zoom-in-up,.is-style-aos-zoom-in-up");
	//  Zoom in down animation
	let aos_zoom_in_down_animation = document.querySelectorAll(".aos-zoom-in-down");
	//  Zoom in left animation
	let aos_zoom_in_left_animation = document.querySelectorAll(".aos-zoom-in-left");
	//  Zoom in right animation
	let aos_zoom_in_right_animation = document.querySelectorAll(".aos-zoom-in-right");

	if (all_firstslide) {
		for (let i = 0; i < all_firstslide.length; i++) {
			all_firstslide[i].setAttribute("data-aos", "fade-left");
			all_firstslide[i].setAttribute("data-aos-duration", "500");
			// all_firstslide[i].setAttribute("data-aos-offset","100");
		}
	}
	if (all_secondslide) {
		for (let i = 0; i < all_secondslide.length; i++) {
			all_secondslide[i].setAttribute("data-aos", "fade-left");
			all_secondslide[i].setAttribute("data-aos-duration", "800");
			// all_secondslide[i].setAttribute("data-aos-offset","400");
		}
	}
	if (all_thirdslide) {
		for (let i = 0; i < all_thirdslide.length; i++) {
			all_thirdslide[i].setAttribute("data-aos", "fade-left");
			all_thirdslide[i].setAttribute("data-aos-duration", "1200");
			// all_thirdslide[i].setAttribute("data-aos-offset","800");
		}
	}

	//  Fade left animation
	if (aos_fade_left_animation) {
		for (let i = 0; i < aos_fade_left_animation.length; i++) {
			aos_fade_left_animation[i].setAttribute("data-aos", "fade-left");
		}
	}
	//  Fade right animation
	if (aos_fade_right_animation) {
		for (let i = 0; i < aos_fade_right_animation.length; i++) {
			aos_fade_right_animation[i].setAttribute("data-aos", "fade-right");
		}
	}
	//  Fade right animation slow
	if (aos_fade_right_slow_animation) {
		for (let i = 0; i < aos_fade_right_slow_animation.length; i++) {
			aos_fade_right_slow_animation[i].setAttribute("data-aos", "fade-right");
			aos_fade_right_slow_animation[i].setAttribute(
				"data-aos-duration",
				"1200"
			);
		}
	}
	//  Fade up animation
	if (aos_fade_up_animation) {
		for (let i = 0; i < aos_fade_up_animation.length; i++) {
			aos_fade_up_animation[i].setAttribute("data-aos", "fade-up");
		}
	}
	//  Fade down animation
	if (aos_fade_down_animation) {
		for (let i = 0; i < aos_fade_down_animation.length; i++) {
			aos_fade_down_animation[i].setAttribute("data-aos", "fade-down");
		}
	}
	//  Zoom in animation
	if (aos_zoom_in_animation) {
		for (let i = 0; i < aos_zoom_in_animation.length; i++) {
			aos_zoom_in_animation[i].setAttribute("data-aos", "zoom-in");
		}
	}
	//  Zoom out animation
	if (aos_zoom_out_animation) {
		for (let i = 0; i < aos_zoom_out_animation.length; i++) {
			aos_zoom_out_animation[i].setAttribute("data-aos", "zoom-out");
		}
	}
	//  Flip left animation
	if (aos_flip_left_animation) {
		for (let i = 0; i < aos_flip_left_animation.length; i++) {
			aos_flip_left_animation[i].setAttribute("data-aos", "flip-left");
		}
	}
	//  Flip right animation
	if (aos_flip_right_animation) {
		for (let i = 0; i < aos_flip_right_animation.length; i++) {
			aos_flip_right_animation[i].setAttribute("data-aos", "flip-right");
		}
	}
	//  Flip up out animation
	if (aos_flip_up_animation) {
		for (let i = 0; i < aos_flip_up_animation.length; i++) {
			aos_flip_up_animation[i].setAttribute("data-aos", "flip-up");
		}
	}
	//  Flip down animation
	if (aos_flip_down_animation) {
		for (let i = 0; i < aos_flip_down_animation.length; i++) {
			aos_flip_down_animation[i].setAttribute("data-aos", "flip-down");
		}
	}
	//  Zoom in up animation
	if (aos_zoom_in_up_animation) {
		for (let i = 0; i < aos_zoom_in_up_animation.length; i++) {
			aos_zoom_in_up_animation[i].setAttribute("data-aos", "zoom-in-up");
		}
	}
	//  Zoom in down animation
	if (aos_zoom_in_down_animation) {
		for (let i = 0; i < aos_zoom_in_down_animation.length; i++) {
			aos_zoom_in_down_animation[i].setAttribute("data-aos", "zoom-in-down");
		}
	}
	//  Zoom in left animation
	if (aos_zoom_in_left_animation) {
		for (let i = 0; i < aos_zoom_in_left_animation.length; i++) {
			aos_zoom_in_left_animation[i].setAttribute("data-aos", "zoom-in-left");
		}
	}
	//  Zoom in right animation
	if (aos_zoom_in_right_animation) {
		for (let i = 0; i < aos_zoom_in_right_animation.length; i++) {
			aos_zoom_in_right_animation[i].setAttribute("data-aos", "zoom-in-right");
		}
	}
};

// JavaScript code for gradient change //
const buttons = document.querySelectorAll('.wp-block-button__link');

function hasGradientBackground(element) {
	const backgroundImage = window.getComputedStyle(element).backgroundImage;
	return backgroundImage.includes('gradient');
}

function reverseGradient(element) {
	const backgroundImage = window.getComputedStyle(element).backgroundImage;
	const reversedGradient = backgroundImage.replace(/linear-gradient\(([^,]+),/, (match, p1) => {
		let newDirection;
		if (p1.includes('deg')) {
			const angle = parseFloat(p1);
			newDirection = (angle + 180) % 360 + 'deg';
		} else {
			const directions = {
				'to top': 'to bottom',
				'to bottom': 'to top',
				'to left': 'to right',
				'to right': 'to left',
				'to top left': 'to bottom right',
				'to top right': 'to bottom left',
				'to bottom left': 'to top right',
				'to bottom right': 'to top left'
			};
			newDirection = directions[p1] || p1;
		}
		return `linear-gradient(${newDirection},`;
	});
	element.style.backgroundImage = reversedGradient;
}

buttons.forEach(button => {
	if (hasGradientBackground(button)) {
		const originalBackground = window.getComputedStyle(button).backgroundImage;

		button.addEventListener('mouseover', () => {
			reverseGradient(button);
		});

		button.addEventListener('mouseout', () => {
			button.style.backgroundImage = originalBackground;
		});
	}
});

function ps_initThemeToggle() {
	// Check if theme-toggle element exists
	const toggleSwitch = document.getElementById('theme-toggle');
	if (!toggleSwitch) {
		return; // Exit if the theme toggle doesn't exist
	}

	// Get the current theme from localStorage or set it to 'light' by default
	const currentTheme = localStorage.getItem('theme') || 'light';

	// Apply the stored theme (dark or light)
	if (currentTheme === 'dark') {
		document.body.classList.add('dark-mode');
	}

	// Toggle theme on button click
	toggleSwitch.addEventListener('click', function () {
		document.body.classList.toggle('dark-mode');
		let theme = document.body.classList.contains('dark-mode') ? 'dark' : 'light';
		localStorage.setItem('theme', theme); // Save the selected theme in localStorage
	});
}

// sticky header on scroll with animation
// function handleStickyHeaderOnScroll() {
// 	if (screen.width > 960) {
// 		var previousScrollpos = window.scrollY; // Use scrollY instead of screenY

// 		window.addEventListener("scroll", (event) => {
// 			var currentScrollPos = window.scrollY;
// 			//console.log(currentScrollPos); // This can be removed after testing
// 			let site_header = document.querySelector(".site-header");
// 			let site_body = document.querySelector(".transparent_header");
// 			let ps_position = (site_body) ? 'relative' : 'relative';

// 			// Handle scroll up (show header)
// 			if (previousScrollpos > currentScrollPos) {
// 				site_header.style.top = "0";
// 				if (currentScrollPos > 100) {
// 					site_header.classList.add("header-show");
// 					site_header.style.position = 'sticky';
// 				}
// 			} else { // Handle scroll down (hide header)
// 				site_header.style.top = "-100px";
// 				site_header.classList.remove("header-show");
// 				site_header.style.position = ps_position;
// 			}

// 			// Reset header position if at the top of the page
// 			if (currentScrollPos < 100) {
// 				site_header.style.position = ps_position;
// 				site_header.classList.remove("header-show");
// 			}

// 			// Update previous scroll position
// 			previousScrollpos = currentScrollPos;
// 		});
// 	}
// }
function handleStickyHeaderOnScroll() {
	if (window.innerWidth > 960) {
		let previousScrollpos = window.scrollY;
		const site_header = document.querySelector(".site-header");

		window.addEventListener("scroll", () => {
			let currentScrollPos = window.scrollY;

			if (previousScrollpos > currentScrollPos) {
				// Scroll up → show
				site_header.classList.remove("header-hide");
				site_header.classList.add("header-show");
			} else {
				// Scroll down → hide
				site_header.classList.add("header-hide");
				site_header.classList.remove("header-show");
			}

			if (currentScrollPos < 100) {
				site_header.classList.remove("header-hide", "header-show");
			}

			previousScrollpos = currentScrollPos;
		});
	}
}
function ps_initAccordionTabs(scope = document) {

	function stripWPInteractivity(el) {
		if (!el) return;

		el.removeAttribute('data-wp-context');

		el.querySelectorAll(
			'[data-wp-on--click], [data-wp-on--keydown], [data-wp-bind--aria-expanded], [data-wp-context]'
		).forEach(node => {
			node.removeAttribute('data-wp-on--click');
			node.removeAttribute('data-wp-on--keydown');
			node.removeAttribute('data-wp-bind--aria-expanded');
			node.removeAttribute('data-wp-context');
		});
	}

	const accordions = scope.querySelectorAll(".wp-block-accordion.tabs-v5");

	accordions.forEach((accordion) => {
		if (accordion.dataset.tabsInitialized === "true") return;
		accordion.dataset.tabsInitialized = "true";

		const items = accordion.querySelectorAll(":scope > .wp-block-accordion-item");
		if (!items.length) return;

		const tabsNav = document.createElement("div");
		tabsNav.className = "ps-tabs-nav";

		const tabsContent = document.createElement("div");
		tabsContent.className = "ps-tabs-content";

		let defaultButton = null;

		// ---- Move Headings & Panels ----
		items.forEach((item, index) => {
			const heading = item.querySelector(":scope > .wp-block-accordion-heading");
			const panel = item.querySelector(":scope > .wp-block-accordion-panel");
			const button = heading?.querySelector(".wp-block-accordion-heading__toggle");

			
			stripWPInteractivity(item);
			stripWPInteractivity(heading);
			stripWPInteractivity(panel);
			if (button) {
				button.removeAttribute('data-wp-on--click');
				button.removeAttribute('data-wp-on--keydown');
				button.removeAttribute('data-wp-bind--aria-expanded');
			}


			if (heading) tabsNav.appendChild(heading);
			if (panel) {
				panel.style.display = "none"; // hide initially
				tabsContent.appendChild(panel);
			}

			// Detect openByDefault
			const context = item.getAttribute("data-wp-context");
			if (context && context.includes('"openByDefault":true')) {
				defaultButton = button;
			}

			// fallback first tab
			if (!defaultButton && index === 0) {
				defaultButton = button;
			}
		});

		// Clear original structure
		accordion.innerHTML = "";
		accordion.appendChild(tabsNav);
		accordion.appendChild(tabsContent);

		const buttons = tabsNav.querySelectorAll(".wp-block-accordion-heading__toggle");
		const panels = tabsContent.querySelectorAll(".wp-block-accordion-panel");
		const headings = tabsNav.querySelectorAll(".wp-block-accordion-heading");

		// Store original background color from CMS (inline style)
		headings.forEach((heading) => {
			if (!heading.dataset.originalBg) {
				heading.dataset.originalBg = heading.style.backgroundColor || "";
			}
		});

		//  Open Tab 
		function openTab(button, { moveFocus = false } = {}) {
			const panelId = button.getAttribute("aria-controls");
			const panel = tabsContent.querySelector("#" + panelId);
			if (!panel) return;

			// Reset all
			buttons.forEach((btn) => {
				const h = btn.closest(".wp-block-accordion-heading");
				btn.setAttribute("aria-expanded", "false");
				btn.setAttribute("tabindex", "-1");
				h.classList.remove("is-active");
				h.style.backgroundColor = h.dataset.originalBg || "";
			});

			panels.forEach((p) => {
				p.style.display = "none";
				p.classList.remove("is-active");
				p.setAttribute("inert", "");
				p.setAttribute("aria-hidden", "true");
			});

			// Activate current
			const heading = button.closest(".wp-block-accordion-heading");
			button.setAttribute("aria-expanded", "true");
			button.setAttribute("tabindex", "0");
			heading.classList.add("is-active");

			const isMobile = window.matchMedia("(max-width: 767px)").matches;
			heading.style.backgroundColor = isMobile ? "#12284B" : "#F5F5F5";

			panel.style.display = "block";
			panel.classList.add("is-active");
			panel.removeAttribute("inert");
			panel.setAttribute("aria-hidden", "false");

			// Move focus only when requested (keyboard interaction)
			if (moveFocus) {
				const focusable = panel.querySelector(
					'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
				);
				(focusable || panel).focus();
			}
		}

		// ---- Click Events ----
		buttons.forEach((button) => {
			button.addEventListener("click", function (e) {
				e.preventDefault();
				// Mouse click: do not move focus inside panel
				openTab(button, { moveFocus: false });
			});

			// (Optional) Support Enter/Space on button itself
			button.addEventListener("keydown", (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					openTab(button, { moveFocus: true });
				}
			});
		});

		// ---- Keyboard Roving / Arrow Nav ----
		buttons.forEach((button, index) => {
			button.addEventListener("keydown", (e) => {
				let newIndex = null;

				switch (e.key) {
					case "ArrowRight":
						newIndex = (index + 1) % buttons.length;
						break;
					case "ArrowLeft":
						newIndex = (index - 1 + buttons.length) % buttons.length;
						break;
					case "Home":
						newIndex = 0;
						break;
					case "End":
						newIndex = buttons.length - 1;
						break;
					default:
						return;
				}

				e.preventDefault();
				// Keep focus on the *button* when arrowing
				buttons[newIndex].focus();
				// But open the tab and move focus into panel (optional)
				openTab(buttons[newIndex], { moveFocus: true });
			});
		});

		// ---- Click Events ----
		buttons.forEach((button) => {
			button.addEventListener("click", function (e) {
				e.preventDefault();
				// Mouse click: do not move focus inside panel
				openTab(button, { moveFocus: false });
			});

			// (Optional) Support Enter/Space on button itself
			button.addEventListener("keydown", (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					openTab(button, { moveFocus: true });
				}
			});
		});

		// ---- Keyboard Roving / Arrow Nav ----
		buttons.forEach((button, index) => {
			button.addEventListener("keydown", (e) => {
				let newIndex = null;

				switch (e.key) {
					case "ArrowRight":
						newIndex = (index + 1) % buttons.length;
						break;
					case "ArrowLeft":
						newIndex = (index - 1 + buttons.length) % buttons.length;
						break;
					case "Home":
						newIndex = 0;
						break;
					case "End":
						newIndex = buttons.length - 1;
						break;
					default:
						return;
				}

				e.preventDefault();
				// Keep focus on the *button* when arrowing
				buttons[newIndex].focus();
				// But open the tab and move focus into panel (optional)
				openTab(buttons[newIndex], { moveFocus: true });
			});
		});

		// ---- Click Events ----
		buttons.forEach((button) => {
			button.addEventListener("click", function (e) {
				e.preventDefault();
				openTab(button);
			});
		});
		buttons.forEach((button, index) => {
			button.addEventListener("keydown", (e) => {
				let newIndex = null;

				switch (e.key) {
					case "ArrowRight":
						newIndex = (index + 1) % buttons.length;
						break;

					case "ArrowLeft":
						newIndex = (index - 1 + buttons.length) % buttons.length;
						break;

					case "Home":
						newIndex = 0;
						break;

					case "End":
						newIndex = buttons.length - 1;
						break;

					default:
						return;
				}

				e.preventDefault();
				buttons[newIndex].focus();
				openTab(buttons[newIndex]);
			});
		});

		// ---- Open Default ----
		if (defaultButton) {
			openTab(defaultButton);
		}
	});
}


document.addEventListener('DOMContentLoaded', function () {

	function syncAccordion() {
		document.querySelectorAll('.wp-block-accordion-panel').forEach(panel => {
			const button = document.querySelector(
				'[aria-controls="' + panel.id + '"]'
			);

			if (button) {
				panel.removeAttribute('inert');
			} else {
				panel.setAttribute('inert', '');
			}
		});
	}

	// Run once on load (for default active panel)
	setTimeout(syncAccordion, 200);

	// Run after every click
	document.addEventListener('click', function () {
		setTimeout(syncAccordion, 100);
	});

});

document.querySelectorAll('.ps-case-studies-link').forEach(link => {
  const parent = link.closest('.ps-case-studies-item');
if (!parent) return;
  link.addEventListener('focus', () => {
    if (parent) parent.style.overflow = 'visible';
  });

  link.addEventListener('blur', () => {
    if (parent) parent.style.overflow = '';
  });
});

document.querySelectorAll('.ps-related-case-studies-link').forEach(link => {
  const parent = link.closest('.ps-related-case-studies-item');
if (!parent) return;
  link.addEventListener('focus', () => {
    if (parent) parent.style.overflow = 'visible';
  });

  link.addEventListener('blur', () => {
    if (parent) parent.style.overflow = '';
  });
});

document.addEventListener('focusin', (e) => {
  if (e.target.matches('.ps-case-studies-link')) {
    const parent = e.target.closest('.ps-case-studies-item');
    if (parent) parent.style.overflow = 'visible';
  }
});

document.addEventListener('focusout', (e) => {
  if (e.target.matches('.ps-case-studies-link')) {
    const parent = e.target.closest('.ps-case-studies-item');
    if (parent) parent.style.overflow = '';
  }
});

document.querySelectorAll('.ps-component-case-studies-link').forEach(link => {
  const parent = link.closest('.ps-component-case-studies-item');
if (!parent) return;
  link.addEventListener('focus', () => {
    if (parent) parent.style.overflow = 'visible';
  });

  link.addEventListener('blur', () => {
    if (parent) parent.style.overflow = '';
  });
});


function initClickableCards(selector = '.is-style-hover-info-card') {

    const cards = document.querySelectorAll(selector);

    cards.forEach(card => {

        const link = card.querySelector('a');

        // Skip if no link
        if (!link) return;

        // Accessibility
        card.setAttribute('tabindex', '0');
        card.setAttribute('role', 'link');
        card.setAttribute('aria-label', link.textContent.trim());

        card.style.cursor = 'pointer';

        // Click handler
        card.addEventListener('click', function (e) {
            if (e.target.closest('a')) return;
            link.click();
        });

        // Keyboard support
        card.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                link.click();
            }
        });

    });

}

// customize footer section code
(function () {
  let boundContainer = null;
  let keyHandler = null;

  function isVisible(el) {
    const cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetParent !== null;
  }

  function getFocusable(container) {
    if (!container) return [];
    const nodes = container.querySelectorAll(
      'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
      'select:not([disabled]), textarea:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]'
    );
    return Array.from(nodes).filter(el => el.tabIndex !== -1 && isVisible(el));
  }

  function attach(container, closeBtn) {
    if (closeBtn && !closeBtn.hasAttribute('href') && closeBtn.tabIndex < 0) {
      closeBtn.tabIndex = 0;
    }

    keyHandler = function (e) {
      if (e.key !== 'Tab') return;

      const focusables = getFocusable(container);
      if (!focusables.length) return;

      const last = focusables[focusables.length - 1];

      // Forward Tab from last → go to close button
      if (!e.shiftKey && document.activeElement === last && closeBtn) {
        e.preventDefault();
        closeBtn.focus();
      }

      // Shift+Tab from close button → go back to last
      if (e.shiftKey && document.activeElement === closeBtn && last) {
        e.preventDefault();
        last.focus();
      }
    };

    container.addEventListener('keydown', keyHandler);
    boundContainer = container;
  }

  function detach() {
    if (boundContainer && keyHandler) {
      boundContainer.removeEventListener('keydown', keyHandler);
    }
    boundContainer = null;
    keyHandler = null;
  }

  function initMobileMenuFocus() {
    detach();

    if (window.innerWidth >= 960) return;

    const container = document.querySelector('.mobile-menu');
    if (!container) return;

    const closeBtn = container.querySelector('.mobile-menu-close-button a');
    if (!closeBtn) return;

    attach(container, closeBtn);
  }

  window.initMobileMenuFocus = initMobileMenuFocus;

  window.addEventListener('load', initMobileMenuFocus);
  window.addEventListener('resize', initMobileMenuFocus);
})();


function handlePSRelatedCaseStudiesLayout() {
	const wrapper = document.querySelector('.ps-related-case-studies-wrapper');
	if (wrapper) {
		const count = wrapper.querySelectorAll('.ps-related-case-studies-item').length;

		if (count === 1) wrapper.classList.add('is-one-item');
		if (count === 2) wrapper.classList.add('is-two-items');
	}
}